import { useState } from 'react';
import { Maximize2, ExternalLink, GraduationCap, X } from 'lucide-react';
import { AppLayout } from '@/components/layout/app-layout';

export function CursoImplementacionPage() {
  const [fullscreen, setFullscreen] = useState(false);

  // En modo fullscreen renderizamos solo el iframe sin AppLayout (ocupa toda la pantalla)
  if (fullscreen) {
    return (
      <div className="fixed inset-0 z-50 flex flex-col bg-white">
        <div className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-purple-600 text-white">
              <GraduationCap size={18} />
            </div>
            <div>
              <h1 className="text-base font-semibold text-slate-900">
                Curso de Implementación · Price Intelligence
              </h1>
              <p className="text-xs text-slate-500">10 lecciones · ~17 minutos</p>
            </div>
          </div>
          <button
            onClick={() => setFullscreen(false)}
            className="flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
          >
            <X size={14} />
            Salir pantalla completa
          </button>
        </div>
        <iframe
          src="/manual-curso/index.html"
          title="Curso de Implementación · Prixia"
          className="flex-1 w-full border-0"
          allow="autoplay; fullscreen"
        />
      </div>
    );
  }

  return (
    <AppLayout>
      <div className="flex flex-col h-[calc(100vh-64px)]">
        <div className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3">
          <div className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-purple-600 text-white">
              <GraduationCap size={18} />
            </div>
            <div>
              <h1 className="text-base font-semibold text-slate-900">
                Curso de Implementación · Price Intelligence
              </h1>
              <p className="text-xs text-slate-500">
                10 lecciones · ~17 minutos · audio narrado · hotspots sincronizados
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <a
              href="/manual-curso/index.html"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
            >
              <ExternalLink size={14} />
              Abrir en pestaña nueva
            </a>
            <button
              onClick={() => setFullscreen(true)}
              className="flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
            >
              <Maximize2 size={14} />
              Pantalla completa
            </button>
          </div>
        </div>

        <iframe
          src="/manual-curso/index.html"
          title="Curso de Implementación · Prixia"
          className="flex-1 w-full border-0"
          allow="autoplay; fullscreen"
        />
      </div>
    </AppLayout>
  );
}

export default CursoImplementacionPage;
